module.exports = __webpack_public_path__ + "img/mine_selected.232616d2.svg";